// extracted by mini-css-extract-plugin
module.exports = {"code-example":"NFHG_","codeExample":"NFHG_","request-code-example":"qluu7","requestCodeExample":"qluu7"};